
import React from 'react';
import $ from 'jquery';
import moment, { Moment } from 'moment';
import cn from 'classnames';

import type { DateRange } from '../../types/dateRange';

import { getDateFormat, CalendarButton } from './DateTimePickerCommon';

require('bootstrap-daterangepicker');
require('bootstrap-daterangepicker/daterangepicker.css');
export type Ranges = {
  [key: string]: Moment[],
};
type Props = {
  name?: string,
  onChange: (dateRange: DateRange) => void,
  value?: DateRange,
  includeTime?: boolean,
  dateFormatString?: string,
  ranges: Ranges,
  className?: string,
  autoApply?: boolean,
  autoUpdateInput?: boolean,
};
class DateTimeRangePicker extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }
  static defaultProps = {
    name: '',
    value: {
      startDate: moment(),
      endDate: moment().add(1, 'd'),
    },
    includeTime: false,
    dateFormatString: 'MM-DD-YYYY',
    className: '',
    autoApply: true,
    autoUpdateInput: false,
  };

  dateRangePickerElement: HTMLDivElement | null = null;

  handleChange = (startDate: Moment, endDate: Moment) => {
    return this.props.onChange({ startDate, endDate });
  };

  getStartDate = () => {
    const { dateFormatString, value } = this.props;
    const result = value?.startDate?.format(dateFormatString || 'MM-DD-YYYY');
    return result;
  }

  getEndDate = () => {
    const { dateFormatString, value } = this.props;
    const result = value?.endDate?.format(dateFormatString || 'MM-DD-YYYY');
    return result;
  }

  componentDidMount = () => {
    if (this.dateRangePickerElement) {
      $(this.dateRangePickerElement).daterangepicker(
        {
          autoUpdateInput: this.props.autoUpdateInput,
          autoApply: this.props.autoApply,
          timePicker: this.props.includeTime,
          ranges: this.props.ranges,
          singleDatePicker: false,
          startDate: this.getStartDate(),
          endDate: this.getEndDate(),
        },
        this.handleChange,
      );
    }
  }

  componentDidUpdate(prevProps: Props) {
    //this is not simply prevProps.value !== this.props.value b/c identical but distinct js objects do not match one another
    // and there's not a standard process to do so (though if it were more complex, we could define a function to do so or use lodash)
    if (
      !(
        prevProps?.value?.startDate === this.props?.value?.startDate &&
        prevProps?.value?.endDate === this.props?.value?.endDate
      )
    ) {
      $(this.dateRangePickerElement)
        .data('daterangepicker')
        .setStartDate(this.getStartDate());
      $(this.dateRangePickerElement)
        .data('daterangepicker')
        .setEndDate(this.getEndDate());
    }
  }

  formatDate = (date: Moment) => {
    const dateFormat: string = getDateFormat(
      this.props.includeTime,
      this.props.dateFormatString,
    );
    if (!date || !date.format) {
      throw new Error('invalid date passed to DateTimeRangePicker');
    } else {
      return date.format(dateFormat);
    }
  }

  getValue = () => {
    const startDate = this.getStartDate(),
      endDate = this.getEndDate();
    if (startDate && endDate) {
      return `${startDate} - ${endDate}`;
    }
    return '';
  }

  render = () => {
    return (
      <div
        className="input-group date-picker-input"
        ref={element => {
          this.dateRangePickerElement = element;
        }}
      >
        <input
          type="text"
          name={this.props.name}
          className={cn(this.props.className, 'form-control')}
          value={this.getValue()}
          onChange={() => {}} /* React wants an onChange, but we don't need it because of jQuery. */
        />
        <CalendarButton />
      </div>
    );
  }
}

export default DateTimeRangePicker;
